const colors = {
  green: "RGB(0, 191, 166)",
};

export default colors;
